















import { Component, Mixins } from 'vue-property-decorator'
import DexieService from '@/services/dexie-service'
import axios from 'axios'
import SnackbarService from '@/services/snackbar-service'
import moment from 'moment-timezone'
import { Cow } from '@/interfaces/Cow'
import CowService from '@/services/cow-service'

@Component({
  components: {},
})
export default class StatisticsView extends Mixins(
  DexieService,
  SnackbarService,
  CowService
) {
  moment: any

  cows: Cow[] = []

  statistic: any = []

  axios: any

  headers = []

  created() {
    this.getCows()
    this.genHeaders()
    this.$store.state.showAppbar = true
    this.$store.state.changeBack = '/home'
    this.$store.state.navbarText = 'Statistica'
  }

  genHeaders() {
    const headers = []
    headers.push({ text: '', value: 'item' })
    this.$store.state.account.farms.forEach((f: any) => {
      headers.push({ text: f.name, value: f.id.toString() })
    })
    headers.push({ text: 'Total', value: 'total' })
    this.headers = headers
  }
  getCows() {
    this.$store.state.loading = true
    if (navigator.onLine) {
      axios
        .get(`/cows-all`)
        .then(res => {
          this.$db.cows.bulkPut(res.data)
          this.cows = this.addPregnantSinceAndAge(res.data)
          this.genStatistics()
        })
        .catch(error => {
          this.notify({ text: `Server error. ${error}` })
          this.cows = []
        })
        .finally(() => {
          this.$store.state.loading = false
        })
    } else {
      this.$db.cows.toArray().then((cows: Cow[]) => {
        cows = this.addPregnantSinceAndAge(cows)
        this.cows = cows
        this.genStatistics()
        this.$store.state.loading = false
      })
    }
  }

  genStatistics() {
    const counts = {
      cowsCount: { total: 0, item: 'Vavas total' },
      femalesCount: { total: 0, item: 'Vavas hembras' },
      malesCount: { total: 0, item: 'Vavas machos' },
      pregnantCount: { total: 0, item: 'Preñadas' },
      soldCount: { total: 0, item: 'Vendidas' },
      deadCount: { total: 0, item: 'Muertos' },
      deadLast10Days: { total: 0, item: 'Muertos ultimas 10 dias' },
      deadLast30Days: { total: 0, item: 'Muertos ultimas 30 dias' },
    }
    this.$store.state.account.farms
      .map((f: any) => f.id)
      .forEach((id: number) => {
        counts.cowsCount[id] = 0
        counts.femalesCount[id] = 0
        counts.malesCount[id] = 0
        counts.pregnantCount[id] = 0
        counts.soldCount[id] = 0
        counts.deadCount[id] = 0
        counts.deadLast10Days[id] = 0
        counts.deadLast30Days[id] = 0
      })
    this.cows.forEach((c: Cow) => {
      if (c.status === 'possession') {
        counts.cowsCount[c.farm_id] += 1
        counts.cowsCount.total += 1
        if (c.female) {
          counts.femalesCount[c.farm_id] += 1
          counts.femalesCount.total += 1
        } else {
          counts.malesCount[c.farm_id] += 1
          counts.malesCount.total += 1
        }
        if (c.pregnancyDate) {
          counts.pregnantCount[c.farm_id] += 1
          counts.pregnantCount.total += 1
        }
      } else if (c.status === 'sold') {
        counts.soldCount[c.farm_id] += 1
        counts.soldCount.total += 1
      } else if (c.status === 'dead') {
        counts.deadCount[c.farm_id] += 1
        counts.deadCount.total += 1
        if (moment(c.date_of_death).isAfter(moment().subtract('day', 10))) {
          counts.deadLast10Days[c.farm_id] += 1
          counts.deadLast10Days.total += 1
        }
        if (moment(c.date_of_death).isAfter(moment().subtract('day', 30))) {
          counts.deadLast30Days[c.farm_id] += 1
          counts.deadLast30Days.total += 1
        }
      }
    })

    Object.keys(counts).forEach((count: string) => {
      const item: any = {
        item: counts[count].item,
        total: counts[count].total.toString(),
      }
      this.$store.state.account.farms
        .map((f: any) => f.id)
        .forEach((id: number) => {
          item[id] = counts[count][id].toString()
        })
      console.log(item)
      this.statistic.push(item)
    })
  }
}
